'use client';

import { useState, type PropsWithChildren } from 'react';
import { useCookie } from 'react-use';

import { EnvironmentContext } from '@/contexts/environmentContext';

import {
  defaultDemoSettings,
  demoSettingsCookieName,
  getDemoSettingsCookieExpiration,
  getDemoSettingsFromCookie,
  type Environment,
} from './environment';

export const EnvironmentProvider = ({
  environment,
  authToken,
  children,
}: PropsWithChildren<{
  environment: Environment;
  authToken: string;
}>) => {
  const [token, setToken] = useState(authToken);
  const [demoSettingsCookie, updateDemoSettingsCookie] = useCookie(
    demoSettingsCookieName
  );

  const [demoSettings, setDemoSettings] = useState(
    environment.isDev
      ? defaultDemoSettings
      : getDemoSettingsFromCookie(demoSettingsCookie)
  );

  return (
    <EnvironmentContext.Provider
      value={{
        ...environment,
        authToken: token,
        updateAuthToken: setToken,
        demoSettings,
        updateDemoSettings: (settings) => {
          setDemoSettings(settings);
          if (!environment.isDev) {
            updateDemoSettingsCookie(JSON.stringify(settings), {
              expires: getDemoSettingsCookieExpiration(),
            });
          }
        },
      }}
    >
      {children}
    </EnvironmentContext.Provider>
  );
};
